import { render, staticRenderFns } from "./SttDictionarySetting.vue?vue&type=template&id=37c35544&scoped=true&"
import script from "./SttDictionarySetting.vue?vue&type=script&lang=js&"
export * from "./SttDictionarySetting.vue?vue&type=script&lang=js&"
import style0 from "./SttDictionarySetting.vue?vue&type=style&index=0&id=37c35544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c35544",
  null
  
)

export default component.exports